// Mock data extra: eventi, forum, messaggi, news, directory, convenzioni, stats
export const MOCK_EVENTI = [
  {
    id: "e1",
    titolo: "Masterclass live: Sostenibilità Digitale e Bilanci ESG",
    tipo: "Masterclass",
    modalita: "online",
    data: "2026-07-15",
    ora: "18:00",
    durata: 90,
    cfdt: 2,
    posti: 100,
    iscritti: 47,
    relatore: "Dott. Andrea Bianchi",
    descrizione: "Una sessione live di approfondimento su come integrare l'ESG nei bilanci aziendali.",
    immagine: "https://images.unsplash.com/photo-1503428593586-e225b39bddfe?w=600&q=80",
    iscritto: true,
  },
  {
    id: "e2",
    titolo: "Workshop AI Pratico per Consulenti",
    tipo: "Workshop",
    modalita: "in presenza",
    luogo: "Milano - Sede A.C.D.T.",
    data: "2026-07-22",
    ora: "10:00",
    durata: 240,
    cfdt: 4,
    posti: 30,
    iscritti: 28,
    relatore: "Ing. Laura Verdi",
    descrizione: "Workshop hands-on per imparare a usare ChatGPT e Claude nella consulenza quotidiana.",
    immagine: "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=600&q=80",
    iscritto: false,
  },
  {
    id: "e3",
    titolo: "Convegno Nazionale A.C.D.T. 2026",
    tipo: "Convegno",
    modalita: "ibrido",
    luogo: "Roma - Auditorium Conciliazione",
    data: "2026-09-12",
    ora: "09:00",
    durata: 480,
    cfdt: 8,
    posti: 500,
    iscritti: 312,
    relatore: "Vari relatori",
    descrizione: "L'evento annuale dell'associazione con tavole rotonde, networking e premi.",
    immagine: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80",
    iscritto: false,
  },
  {
    id: "e4",
    titolo: "Aperitivo Networking Consulenti Lombardia",
    tipo: "Networking",
    modalita: "in presenza",
    luogo: "Milano - The Hub",
    data: "2026-07-30",
    ora: "19:00",
    durata: 120,
    cfdt: 0,
    posti: 60,
    iscritti: 22,
    relatore: "A.C.D.T. Lombardia",
    descrizione: "Serata informale per fare rete tra colleghi consulenti.",
    immagine: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&q=80",
    iscritto: false,
  },
];

export const MOCK_FORUM_CATS = [
  { id: "domande", label: "Domande", color: "#3b82f6", topic: 24 },
  { id: "casi", label: "Casi Studio", color: "#22c55e", topic: 12 },
  { id: "networking", label: "Networking", color: "#f59e0b", topic: 38 },
  { id: "offtopic", label: "Off-Topic", color: "#a78bfa", topic: 17 },
];

export const MOCK_FORUM_TOPIC = [
  {
    id: "t1",
    cat: "domande",
    titolo: "Come compilare il bilancio ESG semplificato?",
    autore: "Lucia Bianchi",
    autoreIniziali: "LB",
    risposte: 8,
    like: 14,
    ultimo: "2 ore fa",
    pinned: true,
    preview: "Buongiorno colleghi, sto seguendo il corso di Sostenibilità Digitale e ho un dubbio sulla parte di bilancio...",
  },
  {
    id: "t2",
    cat: "casi",
    titolo: "Cliente PMI vuole certificazione GDPR completa: da dove partire?",
    autore: "Paolo Verdi",
    autoreIniziali: "PV",
    risposte: 15,
    like: 27,
    ultimo: "ieri",
    preview: "Condivido un caso reale: PMI manifatturiera di 45 dipendenti, vuole rifare tutto da zero...",
  },
  {
    id: "t3",
    cat: "networking",
    titolo: "Aperitivo soci Milano - 30 luglio, chi viene?",
    autore: "Giulia Esposito",
    autoreIniziali: "GE",
    risposte: 22,
    like: 31,
    ultimo: "3 ore fa",
    preview: "Ciao a tutti! Si organizza un aperitivo informale a Milano il 30 luglio. Chi è interessato?",
  },
  {
    id: "t4",
    cat: "domande",
    titolo: "Quali tool AI usate per i report ai clienti?",
    autore: "Andrea Conti",
    autoreIniziali: "AC",
    risposte: 19,
    like: 18,
    ultimo: "2 giorni fa",
    preview: "Curiosità: tra ChatGPT, Claude e Gemini, voi cosa usate più spesso per generare i report?",
  },
];

export const MOCK_MESSAGGI = [
  { id: "m1", nome: "Lucia Bianchi", iniziali: "LB", ultimo: "Grazie per il consiglio sul GDPR!", time: "10:45", nonLetti: 0, online: true },
  { id: "m2", nome: "Paolo Verdi", iniziali: "PV", ultimo: "Ci vediamo all'aperitivo?", time: "ieri", nonLetti: 2, online: false },
  { id: "m3", nome: "Giulia Esposito", iniziali: "GE", ultimo: "Ti mando il template via email", time: "lun", nonLetti: 0, online: true },
  { id: "m4", nome: "Direzione A.C.D.T.", iniziali: "AC", ultimo: "Convocazione assemblea soci", time: "27/06", nonLetti: 1, online: false, ufficiale: true },
];

export const MOCK_CHAT_ATTIVA = {
  conv: "m1",
  nome: "Lucia Bianchi",
  online: true,
  messaggi: [
    { id: 1, dir: "in", testo: "Ciao Mario! Ho visto il tuo intervento al forum sul GDPR, complimenti.", time: "10:30" },
    { id: 2, dir: "out", testo: "Grazie Lucia! È un argomento che mi appassiona molto.", time: "10:35" },
    { id: 3, dir: "in", testo: "Avresti dei consigli su come strutturare un audit veloce per PMI?", time: "10:38" },
    { id: 4, dir: "out", testo: "Certo, io di solito uso una checklist in 12 punti. Te la giro per email!", time: "10:42" },
    { id: 5, dir: "in", testo: "Grazie per il consiglio sul GDPR!", time: "10:45" },
  ],
};

export const MOCK_NEWS = [
  {
    id: "n1",
    titolo: "Pubblicato il nuovo Codice Deontologico A.C.D.T. 2026",
    categoria: "Ufficiale",
    data: "2026-06-15",
    autore: "Direzione A.C.D.T.",
    estratto: "Il direttivo ha approvato l'aggiornamento del Codice Deontologico con nuove disposizioni sull'uso dell'AI nella consulenza.",
    immagine: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80",
    pinned: true,
  },
  {
    id: "n2",
    titolo: "Decreto Trasparenza: cosa cambia per i consulenti dal 1 luglio",
    categoria: "Normativa",
    data: "2026-06-10",
    autore: "Avv. Sandra Romano",
    estratto: "Analisi delle novità introdotte dal decreto e degli adempimenti obbligatori per gli iscritti al Registro.",
    immagine: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80",
  },
  {
    id: "n3",
    titolo: "Aperte le iscrizioni al Convegno Nazionale 2026",
    categoria: "Eventi",
    data: "2026-06-05",
    autore: "Segreteria",
    estratto: "Il 12 settembre a Roma si terrà il convegno annuale. Sono disponibili 500 posti tra presenza e streaming.",
    immagine: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&q=80",
  },
];

export const MOCK_DIRECTORY = [
  { id: "d1", nome: "Lucia Bianchi", citta: "Milano", specializzazione: "GDPR & Privacy", anni: 8, iniziali: "LB", verificato: true, registro: true },
  { id: "d2", nome: "Paolo Verdi", citta: "Roma", specializzazione: "Sostenibilità & ESG", anni: 12, iniziali: "PV", verificato: true, registro: true },
  { id: "d3", nome: "Giulia Esposito", citta: "Napoli", specializzazione: "AI & Automazione", anni: 5, iniziali: "GE", verificato: true, registro: true },
  { id: "d4", nome: "Andrea Conti", citta: "Torino", specializzazione: "Cybersecurity", anni: 10, iniziali: "AC", verificato: true, registro: false },
  { id: "d5", nome: "Marta Russo", citta: "Bologna", specializzazione: "Marketing Digitale Etico", anni: 6, iniziali: "MR", verificato: true, registro: true },
  { id: "d6", nome: "Stefano De Luca", citta: "Firenze", specializzazione: "Blockchain & Web3", anni: 4, iniziali: "SL", verificato: false, registro: false },
];

export const MOCK_CONVENZIONI = [
  { id: "c1", brand: "Pigreco", categoria: "Privacy & GDPR", sconto: "30%", desc: "Tool di compliance GDPR scontato per soci A.C.D.T.", codice: "ACDT30", colore: "#3b82f6" },
  { id: "c2", brand: "E.S.S.E.", categoria: "Formazione AI", sconto: "25%", desc: "Sconto sui workshop AI avanzati", codice: "ESSE25", colore: "#a78bfa" },
];

export const MOCK_STATS = {
  oreStudioMese: [
    { m: "Gen", v: 4 }, { m: "Feb", v: 6 }, { m: "Mar", v: 8 }, { m: "Apr", v: 12 },
    { m: "Mag", v: 9 }, { m: "Giu", v: 14 }, { m: "Lug", v: 7 },
  ],
  cfdtMese: [
    { m: "Gen", v: 0 }, { m: "Feb", v: 0 }, { m: "Mar", v: 2 }, { m: "Apr", v: 8 },
    { m: "Mag", v: 2 }, { m: "Giu", v: 2 }, { m: "Lug", v: 0 },
  ],
  totali: {
    oreStudio: 60,
    corsi: 3,
    cfdtTotali: 14,
    eventiPartecipati: 4,
    forumPost: 17,
    networking: 12,
  },
  mediaSoci: {
    oreStudio: 42,
    cfdtTotali: 11,
  },
};
